export default {"src":"/_next/static/media/facebook.104426d9.svg","height":512,"width":320,"blurWidth":0,"blurHeight":0};